<template>
  <div class="material-center-settings app-container">
    <div class="global-header-wrap">
      <h3>素材中心首页配置</h3>
    </div>
    <el-card class="app-table-container">
      <el-tabs v-model="currentTab" @tab-click="handleTabClick">
        <el-tab-pane label="布局配置" name="layoutConfig">
          <layout-config v-if="currentTab === 'layoutConfig'" />
        </el-tab-pane>
        <el-tab-pane label="Banner素材库" name="bannerMaterialLibrary">
          <banner-material-library
            v-if="currentTab === 'bannerMaterialLibrary'"
          />
        </el-tab-pane>
        <el-tab-pane label="卡片素材库" name="cardMaterialLibrary">
          <card-material-library
            v-if="currentTab === 'cardMaterialLibrary'"
          />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import LayoutConfig from "./layoutConfig/index.vue";
import CardMaterialLibrary from "./cardMaterialLibrary/index.vue";
import BannerMaterialLibrary from "./bannerMaterialLibrary/index.vue";

export default {
  name: "MaterialCenterSettings",
  components: {
    LayoutConfig,
    CardMaterialLibrary,
    BannerMaterialLibrary
  },
  data() {
    return {
      currentTab: "layoutConfig"
    };
  },
  methods: {
    handleTabClick(tab) {
      this.currentTab = tab.name;
    }
  }
};
</script>

<style scoped>
.material-center-settings {
  padding: 0;
  margin: 0;
}

:deep(.el-tabs) {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

:deep(.el-tabs__content) {
  flex: 1;
  overflow: hidden;
}

:deep(.el-tab-pane) {
  height: 100%;
}
:deep(.app-table-container) {
  margin: 0;
}
:deep(.app-table-container .el-card__body) {
  padding: 0;
}
:deep(.app-table-container .el-card__body .el-tabs__content) {
  padding: 0;
}
</style>

